var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.finalClass,attrs:{"id":_vm.id,"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }